export const styles = {
    primary: "#00BEC9"
}